import React, { useContext, useState, useEffect, useRef } from 'react'
import CustomTable from '@/product/components/molecules/CustomTable'
import { useFormik } from 'formik'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SettingContext from '@/product/context/setting/settingContext'
import Loaders from '@/product/components/molecules/Loaders'

const BuyerJourney = (props) => {
    let data = props.data
    const settingcontext = useContext(SettingContext)

    const [isLoading, setIsLoading] = useState(true)

    const { searchTableFetch, search_fetch_data } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const [changeDelStatus, setChangeDelStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [tableBody, setTableBody] = useState([])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'bj.id',
            primaryTable: 'buyer_journey',
            tableJoins: [
                {
                    baseTable: 'users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
            ],
            filters: {
                user_id: {
                    type: 'in',
                    value: '',
                    field: 'bj.user_id',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'buyer_journey')
            setIsLoading(true)
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'buyer_journey') {
                search_fetch_data.records.map((ele) => {
                    ele.fullname = `${ele.first_name} ${
                        ele.last_name ? ele.last_name : ''
                    }`
                })
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (props.data.popup && props.data.id) {
            formikView.values.filters.user_id.value = props.data.id
            formikView.values.page = 1
            searchTableFetch(formikView.values, 'buyer_journey')
            setIsLoading(true)
        } else if (!props.data.popup) {
            setTableBody([])
            setIsLoading(false)
        }
    }, [props.data.popup, props.data.id])

    // const searchInfo = {
    //     formik: formikView,
    //     data: [
    //         {
    //             label: 'Report Name',
    //             placeholder: 'Enter Report Name',
    //             class: 'col-md-4 col-sm-6 col-12',
    //             type: 'text',
    //             name: 'report_name',
    //             filter: true,
    //         },
    //     ],
    // }

    const tableValues = [
        // {
        //     field: 'id',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'ID',
        //     filterable: true,
        //     filterField: 'bj.id',
        // },
        {
            field: 'users_first_name,users_last_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Name',
            filterable: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Email',
            filterable: true,
            filterField: 'u.first_name',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            sort: true,
            filterField: 'bj.created_at',
            disablePadding: false,
            label: 'Created At',
        },
        {
            field: 'api_url',
            type: '',
            firstChild: true,
            sort: false,
            filterField: 'bj.created_at',
            disablePadding: false,
            label: 'Buyer Journey',
        },
        {
            field: 'description',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: true,
            label: 'Description',
        },
        {
            field: 'ip_address',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: false,
            label: 'IP Address',
        },
    ]

    const closeFunction = () => {
        props.function(false, '', 0)
        formikView.resetForm()
    }

    return (
        <>
            <FullScreenPopup
                modaltitle={`Buyer's Journey`}
                open={data.status === 'buyer_journey' ? data.popup : false}
                handleClose={closeFunction}
            >
                <div className="dashboard staticPages">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <CustomTable
                            formik={formikView.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={search_fetch_data}
                            fromVariable={'buyer_journey'}
                            changeTableFunction={searchTableFetch}
                        />
                    )}
                </div>
            </FullScreenPopup>
        </>
    )
}
export default BuyerJourney
